import tables from './tables';
import utils from '../utils';

const findCartData = (url, data) => {
  const isAmazonFresh = isFreshUrl(url);
  const isWholeFoods = url.indexOf('almBrandId=VUZHIFdob2xlIEZvb2Rz') > -1 ||
    url.indexOf('i=wholefoods') > -1;

  return data.filter(d => {
    // Check Whole Foods first, otherwise we may match Fresh cart
    if (isWholeFoods) return d.cartPlatform === 'whole-foods';
    if (isAmazonFresh) return d.cartPlatform === 'amazon-fresh';

    return d;
  })[0];
};

const getCartIdFromUrl = async (url, getActiveCarts, token) => {
  // used for adding links to players
  const [cartFromPath, cartFromHost] = await Promise.all([
    // check if there is a matching url that contains the same path
    // e.g. amazon.com/afx/ingredients/landing for amazon fresh
    utils.getFromMikMakFirebaseService(
      `get/${tables.retailerCarts}?orderBy=productPageHostName&equalTo=${encodeURIComponent(utils.getHostNameFromUrl(url, true))}`, // eslint-disable-line max-len
      token,
    ),
    // also check with just host name - most carts match here
    utils.getFromMikMakFirebaseService(
      `get/${tables.retailerCarts}?orderBy=productPageHostName&equalTo=${encodeURIComponent(utils.getHostNameFromUrl(url))}`, // eslint-disable-line max-len
      token,
    ),
  ]);

  if (!cartFromPath.success && !cartFromHost.success) return;
  if (!cartFromPath.data.length && !cartFromHost.data.length) return;

  const cartData = cartFromPath.data.length ? cartFromPath.data : cartFromHost.data;

  return findCartData(url, getActiveCarts ? filterActiveCarts(cartData) : cartData);
};

const getCartById = async (id, token) => {
  try {
    const { data: cart } = await utils.getFromMikMakFirebaseService(
      `getById/${tables.retailerCarts}/${id}`,
      token,
    );

    return cart;
  } catch (e) {
    throw `Error getting cart from id ${id}: ${e}`;
  }
};

const getAllActiveCarts = async (token) => {
  try {
    const { data: carts } = await utils.getFromMikMakFirebaseService(
      `get/${tables.retailerCarts}?orderBy=active&equalTo=true`,
      token,
    );

    if (!carts) return;

    return carts.reduce((cartMap, cart) => {
      cartMap[cart.id] = cart;

      return cartMap;
    }, {});
  } catch (e) {
    throw `Error getting carts: ${e}`;
  }
};

const getAllInactiveCarts = async (token) => {
  try {
    const { data: carts } = await utils.getFromMikMakFirebaseService(
      `get/${tables.retailerCarts}?orderBy=active&equalTo=false`,
      token,
    );

    if (!carts) return;

    return carts.reduce((cartMap, cart) => {
      cartMap[cart.id] = cart;

      return cartMap;
    }, {});
  } catch (e) {
    throw `Error getting carts: ${e}`;
  }
};

const setCart = async (cart, token) => {
  try {
    const { id } = cart;

    await utils.postToMikMakFirebaseService(`set/${tables.retailerCarts}/${id}`, cart, token);
    await utils.callProductService(`refreshLivePlayerDataWithCart?cartId=${id}`);

    return cart;
  } catch (e) {
    throw `Error creating cart: ${e}`;
  }
};

const getParentCompanies = async (token) => {
  try {
    const { data: parentCompanies, success } = await utils.getFromMikMakFirebaseService(
      `get/${tables.parentCompanies}`,
      token,
    );

    if (!success) throw new Error('error retrieving parent company data');

    return parentCompanies;
  } catch (e) {
    throw `Error retrieving parent companies: ${e.message}`;
  }
};

const getDiscoverCarts = async (token) => {
  try {
    const { success, data } = await utils.getFromMikMakFirebaseService(
      `get/${tables.retailerCarts}?orderBy=discoverSupport&equalTo=true`,
      token,
    );

    if (!success) throw new Error('error retrieving discover cart data');

    return data;
  } catch (e) {
    throw `Error retrieving discover carts: ${e.message}`;
  }
};

const isFreshUrl = (url) => {
  return url.indexOf('fpw=fresh') > -1 ||
    url.indexOf('fpw=alm') > -1 ||
    url.indexOf('i=amazonfresh') > -1 ||
    url.indexOf('afx/ingredients/landingencoded') > -1;
};

const filterActiveCarts = (carts) => carts.filter(cart => cart.active);

export default {
  getCartIdFromUrl,
  getCartById,
  getAllActiveCarts,
  getAllInactiveCarts,
  setCart,
  getParentCompanies,
  getDiscoverCarts,
};
